import { useNavigate } from 'react-router-dom';
import mic01 from '../../../../assets/img/movil/licencias.jpg';
import mic02 from '../../../../assets/img/movil/pc.jpg';
import mic03 from '../../../../assets/img/movil/banner_licencia.jpg';
import mic04 from '../../../../assets/img/movil/Windows10_Footer_Icon_MSStore.png';
import mic05 from '../../../../assets/img/movil/Windows10_Footer_Icon_Skype.png';
import mic06 from '../../../../assets/img/movil/Logo_Project_108x40.png';
import mic07 from '../../../../assets/img/movil/iconoSharePoint.png';
import mic08 from '../../../../assets/img/movil/Logo_Visio_White_90x40.png';
import mic09 from '../../../../assets/img/movil/Windows10_Footer_Icon_Office.png';
import mic10 from '../../../../assets/img/movil/cintillonube.jpg';
import mic11 from '../../../../assets/img/movil/365.png';
import mic12 from '../../../../assets/img/movil/azure.png';
import mic13 from '../../../../assets/img/movil/microsoft-sql-server-logo.png';
import mic14 from '../../../../assets/img/movil/visual-studio-logo.png';
import './CMMicrosoft.css';

function CMMicrosoft() {

    const navigate = useNavigate();

    function navigateView(name:string) {
        navigate("/" + name);
    }

    return (
        <div id="CMMicrosoft">
            <section id="Mic__head">
                <h2>Licenciamiento Microsoft</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Licenciamiento Microsoft</li>
                </ul>
            </section>
            <section id="Mic__section2">
                <figure id="Mics2-content">
                    <img src={mic01} />
                </figure>
                <div id="Mics2-text">
                    <p id="Mics2-text__p1">Licencias<strong> originales</strong></p>
                    <p id="Mics2-text__p2">Adquiere licencias originales de Microsoft y garantiza que tu organización opere de forma segura, productiva y alineada a los estándares actuales.</p>
                    <p id="Mics2-text__p3">Como Socio de Negocios de Microsoft, en INFRASOL te asesoramos en la selección, implementación y administración de soluciones Microsoft.</p>
                    <p id="Mics2-text__p4">Aseguramos el cumplimiento legal, la optimización de costos y el máximo aprovechamiento de la tecnología.</p>
                </div>
            </section>
            <section id="Mic__section3">
                <div id="Mics3-content1">
                    <div id="Mics3-content1__d1">
                        <figure>
                            <img src={mic02} />
                        </figure>
                    </div>
                    <div id="Mics3-content1__d2">
                        <h2>Windows para empresas</h2>
                        <p>Te asesoramos en la elección del sistema operativo más adecuado para tus estaciones de trabajo, dispositivos y servidores, considerando el tamaño, sector y necesidades de tu organización.</p>
                    </div>
                </div>
                <div id="Mics3-content2">
                    <div id="Mics3-content2__d1">
                        <h2>Windows 10 / Windows 11</h2>
                        <div></div>
                        <p id="Mics3-content2__d1--p1">Actualización y migración segura.</p>
                        <p id="Mics3-content2__d1--p2"><strong>Compatibilidad</strong> con hardware y software existente.</p>
                        <p id="Mics3-content2__d1--p3">Configuración recomendada según tu entorno.</p>
                    </div>
                </div>
                <div id="Mics3-content3">
                    <div id="Mics3-content3__d1">
                        <h2>Windows Server</h2>
                        <div></div>
                        <p>Mejora la disponibilidad, seguridad y rendimiento de tus servicios de red y aplicaciones con Windows Server.</p>
                        <p>Virtualización y alta disponibilidad, optimización de almacenamiento y redes, infraestructura de escritorio virtual (VDI) y seguridad avanzada de la información.</p>
                    </div>
                </div>
            </section>
            <section id="Mic__section4">
                <figure id="Mics4-content">
                    <img src={mic03} />
                </figure>
                <div id="Mics4-text">
                    <p id="Mics4-text__p1">Microsoft 365</p>
                    <p id="Mics4-text__p2">Impulsa la productividad de tu empresa con herramientas colaborativas modernas, accesibles desde cualquier lugar y dispositivo.</p>
                    <p id="Mics4-text__p3">Incluye Outlook, Word, Excel, PowerPoint, Exchange Online, Teams, SharePoint Online y OneDrive. Reduce costos de infraestructura y mejora la colaboración entre equipos.</p>
                    <div>
                        <p onClick={() => navigateView("Contacto")}>Solicitar Cotización</p>
                    </div>
                </div>
            </section>
            <section id="Mic__section5">
                <div id="Mics5-content">
                    <ul id="Mics5-content__lista1">
                        <li className="Mics5-lista__item">
                            <div className="Mics5-lista__item--content">
                                <figure>
                                    <img src={mic04} />
                                </figure>
                                <p>Exchange</p>
                            </div>
                            <div className="Mics5-lista__item--text">
                                <p>Correo empresarial seguro y confiable, administrado localmente o desde la nube según tus necesidades (On-Premise y Online).</p>
                            </div>
                        </li>
                        <li className="Mics5-lista--item">
                            <div className="Mics5-lista__item--content">
                                <figure>
                                    <img src={mic05} />
                                </figure>
                                <p>Teams</p>
                            </div>
                            <div className="Mics5-lista__item--text">
                                <p>Herramienta de colaboración y comunicación empresarial que integra chat, videollamadas, reuniones en línea, compartición de archivos y trabajo colaborativo en tiempo real. Se integra con Microsoft 365 y permite trabajar desde cualquier lugar y dispositivo.
                                </p>
                            </div>
                        </li>
                        <li className="Mics5-lista--item">
                            <div className="Mics5-lista__item--content">
                                <figure>
                                    <img src={mic06} />
                                </figure>
                                <p>Project</p>
                            </div>
                            <div className="Mics5-lista__item--text">
                                <p>Herramienta de gestión de proyectos que permite planificar, asignar recursos, hacer seguimiento de tareas y generar reportes de estado. Facilita la coordinación de equipos y la entrega de proyectos a tiempo.</p>
                            </div>
                        </li>
                    </ul>
                    <ul id="Mics5-content__lista2">
                        <li className="Mics5-lista--item">
                            <div className="Mics5-lista__item--content">
                                <figure>
                                    <img src={mic07} />
                                </figure>
                                <p>SharePoint</p>
                            </div>
                            <div className="Mics5-lista__item--text">
                                <p>Plataforma de colaboración y gestión de contenido disponible como SharePoint Server (on-premise) o SharePoint Online (parte de Microsoft 365). Facilita el trabajo colaborativo, la gestión documental, la creación de sitios de equipo y portales empresariales, con acceso seguro desde cualquier lugar y dispositivo.</p>
                            </div>
                        </li>
                        <li className="Mics5-lista--item">
                            <div className="Mics5-lista__item--content">
                                <figure>
                                    <img src={mic08} />
                                </figure>
                                <p>Visio</p>
                            </div>
                            <div className="Mics5-lista__item--text">
                                <p>Herramienta para crear diagramas profesionales, diagramas de flujo, organigramas y diagramas técnicos. Permite simplificar información compleja mediante visualizaciones claras y colaborativas.</p>
                            </div>
                        </li>
                        <li className="Mics5-lista--item">
                            <div className="Mics5-lista__item--content">
                                <figure>
                                    <img src={mic09} />
                                </figure>
                                <p>Office</p>
                            </div>
                            <div className="Mics5-lista__item--text">
                                <p>Suite de productividad que incluye Word, Excel, PowerPoint, Outlook, OneNote y más, disponible como Microsoft 365 (suscripción en la nube) o como versión de escritorio. Permite trabajar de manera unificada desde Windows, Mac y dispositivos móviles, con sincronización en la nube y colaboración en tiempo real.</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
            <section id="Mic__section6">
                <figure id="Mics6-content">
                    <img src={mic10} />
                </figure>
                <div id="Mics6-text">
                    <p id="Mics6-text__p1">Reduce tus costos de infraestructura, personal y equipamiento</p>
                    <p id="Mics6-text__p2">¡INVIERTE EN LA NUBE!</p>
                </div>
            </section>
            <section id="Mic__section7">
                <div id="Mics7-content1">
                    <h4>Office 365</h4>
                    <div></div>
                    <figure>
                        <img src={mic11} />
                    </figure>
                    <p>Con office 365 impulsas la productividad en tu empresa, gracias a a que todo lo que se puede hacer en la oficina, ahora también se puede hacer fuera de esta.
                        Herramientas flexibles que se ajustan a las necesidades de los empleadosde hoy en día para que su grado de satisfacción aumente.</p>
                </div>
                <div id="Mics7-content2">
                    <h4>Microsoft Azure</h4>
                    <div></div>
                    <figure>
                        <img src={mic12} />
                    </figure>
                    <p id="Mics7-content2__p1"><strong>Azure</strong> es la <strong>plataforma de informática en la nube de Microsoft,</strong>una colección cada vez mayor de servicios integrados (análisis, proceso, base de datos, móviles,
                        redes, almacenamiento y web) para moverse con más rapidez, llegar más lejos y ahorrar dinero.</p>
                    <p id="Mics7-content2__p2">Microsoft Azure es una <strong>plataforma abierta y flexible</strong>que le permite construir rápidamente, implementar y administrar aplicaciones a través de una red global
                    de centros de datos gestionados por Microsoft. Integra tus aplicaciones de nube pública con tu entorno de TI actual y genera aplicaciones utilizando cualquier
                        idioma, herramienta o entorno de desarrollo.</p>
                </div>
            </section>
            <section id="Mic__section8">
                <figure id="Mics8-content">
                    <img src={mic10} />
                </figure>
                <div id="Mics8-text">
                    <p id="Mics8-text__p1">Para tu equipo de Desarrollo de Software</p>
                    <p id="Mics8-text__p2">Entornos de desarrollo de aplicaciones e interfaces amigables y fáciles de utilizar</p>
                </div>
            </section>
            <section id="Mic__section9">
                <div id="Mics9-content1">
                    <h4>SQL Server</h4>
                    <div></div>
                    <figure>
                        <img src={mic13} />
                    </figure>
                    <p>Plataforma de base de datos empresarial para aplicaciones críticas, análisis de datos y entornos híbridos.</p>
                </div>
                <div id="Mics9-content2">
                    <h4>Visual Studio</h4>
                    <div></div>
                    <figure>
                        <img src={mic14} />
                    </figure>
                    <p id="Mics9-content2__p1">Entorno de desarrollo integrado para crear aplicaciones modernas para escritorio, web, móviles y nube.</p>
                </div>
            </section>
        </div>
    );
}

export default CMMicrosoft;